import { render, staticRenderFns } from "./sideOptions.vue?vue&type=template&id=7648b6c2&scoped=true&"
import script from "./sideOptions.vue?vue&type=script&lang=js&"
export * from "./sideOptions.vue?vue&type=script&lang=js&"
import style0 from "./sideOptions.vue?vue&type=style&index=0&id=7648b6c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648b6c2",
  null
  
)

export default component.exports